import styled, { css } from 'styled-components'
import { TypographyComponent } from '../../components/Typography'

export const ContainerFlex = styled('div')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;
    justify-content: center;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 3}rem;
    width: 100%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h8};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const Paragraph = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 300;
      font-size: ${theme.typograph.fontsize.h6};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const Strong = styled.strong(
  ({ theme }) => css`
    && {
      font-weight: 500;
    }
  `
)

export const Subtitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h4};
      line-height: ${theme.layout.lineHeight.big};
      color: ${theme.colors.primary.main70};
    }
  `
)

export const CheckBoxLabel = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 500;
      text-transform: uppercase;
      font-size: ${theme.typograph.fontsize.h5};
      line-height: ${theme.layout.lineHeight.big}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const List = styled('ul')(
  ({ theme }) => css`
    padding-left: ${theme.layout.padding.medium};
  `
)

export const ItemList = styled('li')(
  ({ theme }) => css`
    font-size: ${theme.typograph.fontsize.h7};
  `
)
